import { useQuery } from '@apollo/client'

import { GetOrganisationHierarchyInfoModalDocument } from '@/graphql/purchase-plus/generated/getOrganisationHierarchyInfoModal.generated'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'
import { checkNetworkStatus } from '@/modules/shared/utils/checkNetworkStatus'

interface UseGetOrganisationHierarchyInfoModalProps {
  organisationId: number
  skip: boolean
}

export function useGetOrganisationHierarchyInfoModal({
  organisationId,
  skip,
}: UseGetOrganisationHierarchyInfoModalProps) {
  const { data, networkStatus, error, refetch } = useQuery(GetOrganisationHierarchyInfoModalDocument, {
    variables: {
      organisationId,
    },
    context: {
      uri: PURCHASE_PLUS_GRAPHQL_API,
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache',
    skip,
  })

  const organisation = data?.organisation

  const loadingStates = checkNetworkStatus(networkStatus)

  return {
    error,
    organisation,
    loadingStates,
    refetch,
  }
}
